import { ArrowLeft, LayoutDashboard } from "lucide-react";
import { Link } from "react-router";

import { ROUTES } from "@/app/routes";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <p className="text-[7rem] font-black leading-none tracking-tight sm:text-[9rem]">404</p>

      <h1 className="mt-2 text-2xl font-semibold tracking-tight sm:text-3xl">Page introuvable</h1>

      <p className="mt-4 max-w-md text-[15px] text-muted-foreground">
        Cette page n’existe pas ou a été déplacée. Vérifiez l’adresse ou revenez au tableau de bord.
      </p>

      <div className="mt-10 flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
        <Button asChild size="lg">
          <Link to={ROUTES.dashboard}>
            <LayoutDashboard size={18} />
            Aller au tableau de bord
          </Link>
        </Button>

        <Button type="button" variant="outline" size="lg" onClick={() => window.history.back()}>
          <ArrowLeft size={18} />
          Revenir en arrière
        </Button>
      </div>
    </div>
  );
}
